import React, { useState } from 'react';
import HistogramYAxis from './HistogramYAxis';
import HistogramXAxis from './HistogramXAxis';
import HistogramBar from './HistogramBar';
import { getHistogramYAxisValues } from '../../utils';
var Histogram = function (_a) {
    var labels = _a.labels, values = _a.values;
    var _b = useState(undefined), hoveredBar = _b[0], setHoveredBar = _b[1];
    var total = values.reduce(function (accumulator, current) { return accumulator + current; }, 0);
    var maxValue = values.reduce(function (max, current) { return max < current ? current : max; }, 0);
    var maxPercent = Math.ceil(maxValue / total * 100);
    var maxYValue = getHistogramYAxisValues(maxPercent).pop();
    var ticksBetweenBars = labels.length > values.length;
    return (React.createElement("div", { className: "histogram" },
        React.createElement("div", { className: "histogram__container" },
            React.createElement(HistogramYAxis, { maxPercent: maxPercent }),
            React.createElement("div", { className: "histogram__barsWrapper", onMouseLeave: function () { return setHoveredBar(undefined); } }, values.map(function (value, idx) { return React.createElement(HistogramBar, { key: idx, total: total, value: value, barsCnt: values.length, maxYValue: maxYValue, onHover: function () { return setHoveredBar(idx); } }); }))),
        React.createElement(HistogramXAxis, { labels: labels, ticksBetweenBars: ticksBetweenBars, hoveredBarIdx: hoveredBar })));
};
export default Histogram;
//# sourceMappingURL=Histogram.js.map